import AirPassPage from "./airPass";

export default AirPassPage;